export const GEO_IP_LOCATION = 'geoip-location';

export const RECONNECT_TIMEOUT = 3000;
export const SESSION_LIFETIME = 15 * 60 * 1000; // 15 minutes in milliseconds
